// imports
import { Address } from 'abitype';
import { useRef, useEffect } from 'react';
import { Connector, useAccount } from 'wagmi';

// interfaces / types / consts
type Reconnected = boolean | undefined;
interface Props { onDisconnectedCB?: () => void }
interface OnConnect {
  address?: Address;
  isConnected: boolean;
  reconnected: Reconnected;
  connector: Connector | undefined;
}
// exports
export function useConnection(props?: Props): OnConnect {
  const { onDisconnectedCB } = props ?? {};
  const fireDisconnect = useRef(false);
  const reconnected = useRef<Reconnected>();
  const { address, connector, isConnected } = useAccount({
    onConnect({ isReconnected }) { reconnected.current = isReconnected; },
    onDisconnect() {
      fireDisconnect.current = true;
      reconnected.current = undefined;
    }
  });
  useEffect(() => {
    if (fireDisconnect.current) {
      fireDisconnect.current = false;
      if (onDisconnectedCB) { onDisconnectedCB(); }
    }
  });
  return {
    address,
    connector,
    isConnected,
    reconnected: reconnected.current
  };
}
export default { useConnection };
